import Component from 'gia/Component'
import eventbus from 'gia/eventbus';
import stage from '../components/stage'
import renderer from '../components/render'
import bezier from 'bezier-easing'
import scale from '../components/scale'
import _each from 'lodash.foreach'
import gsap from 'gsap'
import barba from '@barba/core';
import Textroll from './textroll'



class Article extends Component {

  constructor(element) {

    super(element)

    this.ease = bezier(.48,0,.12,1);
    this.ease2 = bezier(.25,.46,.45,.94);

    this.body = $('body')
    this.html = $('html')
    this.element = element
    this.el = $(element)

    this.ref = {
      start: null,
      track: null,
      elm: null,
      endtrack: null,
      cover: null,
      coverimg: null,
      vm: []
    }

  }

  mount() {

      this.init = false
      this.track = $('.header--project .text__track')
      this.inside = true
      this.overlayout = false
      this.top = 0
      this.diff = 0


      gsap.to(this.track, .75, {
        alpha: 1,
        force3D: true,
        ease: this.ease,
        delay: .43,
        onComplete: this.complete.bind(this)
      });

      this.toproll = new Textroll(this.ref.start, {
        track: this.ref.track,
        elm: this.ref.elm
      })
      this.toproll.mount()
      this.playtop()

      // this.endroll = new Textroll(this.ref.end, {
      //   track: this.ref.endtrack,
      //   elm: this.ref.endelm
      // })
      // this.endroll.mount()

      eventbus.on('openContact', this.openContact.bind(this));
      eventbus.on('closeContact', this.closeContact.bind(this));


      this.resizeQue = this.resize.bind(this)
      stage.on("stage:resize", this.resizeQue);
      this.renderQue = this.render.bind(this)
      stage.on("stage:scroll", this.renderQue);
    //  this.pr = document.getElementById('pr')
      // $('.pr').on("scroll", this.renderQue);
    //  this.pr.addEventListener('scroll', this.renderQue)
      this.resize(stage);


  }



  complete(){
    this.init = true
  }

  startProject(){

  }

  playtop(){

    !this.topIsPlaying && this.toproll.play()
    this.topIsPlaying = true
  }
  stoptop(){

    this.topIsPlaying && this.toproll.stop()
    this.topIsPlaying = false

  }


  openContact(){

    gsap.to(this.toproll.element, .75, {autoAlpha:0, ease:'expo.out'})
    this.wasPlaying = this.isPlaying
    this.wasPlaying && this.stop()
  }

  closeContact(){
    gsap.to(this.toproll.element, .75, {autoAlpha:1, ease:'expo.in'})
    this.wasPlaying && this.play()
  }


  resize(e){
      this.render(e)
  }

  render(e){

    const box = this.element.getBoundingClientRect()
    this.diff = -this.top + box.top
    this.top = box.top
    // const menuOut = this.diff < 0 && -this.top > 90
    const headerend = -box.top >= stage.h


    _each(this.ref.vm, (el)=>{
      const img = el.getBoundingClientRect();
      $(el).toggleClass('inview', img.top < stage.h)
    })

    $(this.ref.cover).toggleClass('no-header', headerend)
    // this.body.toggleClass('menu-out', menuOut)

    if(headerend){
      this.stoptop()
    }
    else {
      this.playtop()
    }

  }


  unmount() {

    stage.removeListener("stage:resize", this.resizeQue);
    stage.removeListener("stage:scroll", this.renderQue);

  }


}

module.exports = Article
